/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The DownloadDeliveryListRequest model module.
* @module model/DownloadDeliveryListRequest
* @version 2020-12-7
*/
export default class DownloadDeliveryListRequest {
    /**
    * Constructs a new <code>DownloadDeliveryListRequest</code>.
    * @alias module:model/DownloadDeliveryListRequest
    * @class
    * @param customers {Array.<Number>} 顧客ID
    */

    constructor(customers) {
        
        
        this['customers'] = customers;
        
    }

    /**
    * Constructs a <code>DownloadDeliveryListRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/DownloadDeliveryListRequest} obj Optional instance to populate.
    * @return {module:model/DownloadDeliveryListRequest} The populated <code>DownloadDeliveryListRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DownloadDeliveryListRequest();
                        
            
            if (data.hasOwnProperty('customers')) {
                obj['customers'] = ApiClient.convertToType(data['customers'], ['Number']);
            }
        }
        return obj;
    }

    /**
    * 顧客ID
    * @member {Array.<Number>} customers
    */
    'customers' = undefined;




}
